<template>
  <div v-if="product">
    <div v-if="type !== ProductType.CONSTRUCTOR" class="card__body-content">
      <div class="card__body-img">
        <TheProductImage :product="product" :size="ProductImageType.LARGE"/>
        <TheProductTags :product="product"/>
      </div>
      <div class="card__body-block">
        <div class="card__body-column">
          <div class="card__body-info">
            <div class="card__body-top">
              <h1 class="card__body-title">{{ product.name }}</h1>
              <div class="card__body-weight" v-if="product.nutrition.weight_formatted">
                {{ product.nutrition.weight_formatted }}
              </div>
              <div style="padding: 10px; background: #f4e9e6; color: black; border-radius: 12px; margin-bottom: 15px" v-if="product.orderDelayInHours > 0">Данная позиция продается только по предзаказу. Ближайшее время получения через {{ product.orderDelayInHours }} ч.</div>
              <div class="card__body-structure">{{ product.description }}</div>
            </div>
            <div class="card__body-center" v-if="product.nutrition.energy || product.nutrition.proteins">
              <div class="card__body-smalltext">В 100 г.</div>
              <TheNutritionProduct :product="product"/>
            </div>
            <TheProductSizes :product="product" v-model:options="options" @updateOption="updateOption"/>
            <TheProductSupplements v-model:errors="errors" :product="product" v-model:options="options" @updateOption="updateOption"/>
            <div v-if="(options === undefined || options.length === 0) && isMobile" class="empty_block" style="height: 200px"></div>
          </div>

          <div class="card__body-btn" v-if="price > 0">
            <a class="btn" @click="addToCartFromModal({
                product_id: product.product_id,
                options: options
                }); ">
              <TheSpinner v-if="isAddToCartLoading"/>   {{ price }} ₽
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 12H18M12 6V18" stroke="white" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="card__body-content">
      <div class="card__body-left card__body-block">
        <div class="card__body-image-mobile">
          <TheProductImage :product="product" :size="ProductImageType.LARGE"/>
        </div>
        <div class="card__body-title">{{ product.name }}</div>
        <TheProductSizes :product="product" v-model:options="options" @updateOption="updateOption"/>
        <TheProductSupplements v-model:errors="errors" :product="product" v-model:options="options" @updateOption="updateOption"/>
      </div>
      <div class="card__body-right">
        <div class="card__body-right__top">
          <div class="card__body-image">
            <TheProductImage :product="product" :size="ProductImageType.LARGE"/>
          </div>
          <TheProductSupplementsSelectedList :product="product" v-model:optionsList="options"/>

        </div>

        <div class="card__body-right__btn">
          <a class="btn" @click="addToCartFromModal({
                product_id: product.product_id,
                options: options
                }); ">
            <TheSpinner v-if="isAddToCartLoading"/> {{ price }} ₽
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6 12H18M12 6V18" stroke="white" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div  class="card__body-btn__tablet">
      <div class="card__body-btn__wrapper_tablet">
        <a
          class="btn"
          @click="addToCartFromModal({
            product_id: product.product_id,
            options: options
            }); "
        >
          <TheSpinner v-if="isAddToCartLoading"/> {{ price }} ₽
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 12H18M12 6V18" stroke="white" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"></path>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TheProductImage from "@/components/element/TheProductImage.vue";
import TheProductTags from "@/components/element/TheProductTags.vue";
import ProductImageType from "@/enum/ProductImageType.js";
import TheNutritionProduct from "@/components/element/TheNutritionProduct.vue";
import TheProductSizes from "@/components/element/productBlock/TheProductSizes.vue";
import ProductType from "@/enum/ProductType.js";
import TheProductPlusAndMinusBox from "@/components/element/TheProductPlusAndMinusBox.vue";
import TheProductSupplements from "@/components/element/productBlock/TheProductSupplements.vue";
import TheProductSupplementsSelectedList from "@/components/element/productBlock/TheProductSupplementsSelectedList.vue";
import {reactive} from 'vue'
import TheSpinner from "@/components/TheSpinner.vue";
import CartSource from "@/api/CartSource.js";

export default {
  name: 'TheProductContentDetail',
  components: {
    TheSpinner,
    TheProductSupplementsSelectedList,
    TheProductSupplements,
    TheProductPlusAndMinusBox,
    TheProductSizes, TheNutritionProduct, TheProductTags, TheProductImage
  },
  props: {
    product: {
      type: Object
    },
    showToast: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      options: reactive([]),
      isAddToCartLoading: false,
      errors: [],
      price: 0,
      type: null
    }
  },
  computed: {
    ProductType() {
      return ProductType
    },
    ProductImageType() {
      return ProductImageType
    },
    ...mapState({
      'isMobile': state => state.isMobile,
      'shipping': state => state.shipping.shipping,
    }),
  },
  mounted() {
    this.initProduct()
  },
  watch: {
    product(value) {
      if(value){
        this.initProduct()
      }

    },
  },

  methods: {
    ...mapActions({
      'addToCart': 'cart/add',
    }),
    ...mapMutations({
      'setShowProductModal': 'productModal/setShowProductModal',
      'setShowModalSipping': 'shipping/setShowModal',
      'setAddToCartAfterSetShipping': 'shipping/setAddToCartAfterSetShipping',
    }),

    sendYandexEcommerceCartAdd() {
      window?.dataLayer?.push({
        "ecommerce": {
          "currencyCode": "RUB",
          "add": {
            "products": [
              {
                "id": this.product.product_id,
                "name": this.product.name,
                "price": parseInt(this.price) || 0,
                "quantity": 1,
                brand: "Краснодарский парень",
                "list": "Catalog",
                "position": 1
              }
            ]
          }
        }
      });
    },

    async addToCartFromModal({product_id, options = []}) {
      this.errors = [];
      if (this.shipping === null) {
        this.setShowProductModal(false)
         this.setShowModalSipping(true)
         this.setAddToCartAfterSetShipping({
           product_id: product_id,
           options: options ?? [],
         })
        this.$toast.open({
          message: 'Выберите способ получения заказа, чтобы добавить товар в корзину',
          type: 'default',
        });
        return;
      }

      try {
        this.isAddToCartLoading = true;
        const resultOptions = options.reduce((acc, currentObject) => {
          const year = Object.keys(currentObject)[0]
          acc[year] = currentObject[year]
          return acc
        }, {})
        await this.addToCart({
          product_id,
          options: [resultOptions]
        })
        .then(async () => {
          this.sendYandexEcommerceCartAdd()
          this.setShowProductModal(false)
        }).catch((error) => {
          this.errors = error.response?.data?.error;
        }).finally(() => {
          this.isAddToCartLoading = false;
        })
      } finally {
        this.isAddToCartLoading = false;
      }
    },
    initProduct() {
      this.options = [];
      this.priceCalculate();
      this.initDefaultOptions();
      this.detectProductType();
    },
    detectProductType() {
      if (this.product.options.length === 0) {
        this.type = ProductType.DEFAULT
      } else if (this.product.constructor === true) {
        this.type = ProductType.CONSTRUCTOR
      } else if (this.product.options.length > 0) {
        this.type = ProductType.COMPONENT
      }
    },
    async priceCalculate() {
      this.price = parseInt(this.product.price);
      for (const option of this.options) {
        for (const productOption of this.product.options) {
          if (productOption.product_option_id === Object.keys(option)[0]) {
            if (productOption.type === "select") {
              for (const size of productOption.sizes) {
                if (size.product_option_value_id === Object.values(option)[0]) {
                  this.price += parseInt(size.price);
                }
              }
            } else if (productOption.type === "product") {
              for (const supplementProduct of productOption.products) {

                const values = Object.values(option).map(proxyObj => Array.isArray(proxyObj) ? [...proxyObj] : proxyObj);
                if (values.flat().includes(supplementProduct.product_id)) {
                  this.price += parseInt(supplementProduct.price);
                }

              }
            }
          }
        }
      }
    },
    updateOption(key, value, saveOld = false) {
      let found = false;
      this.options.forEach((entry) => {
        if (entry.hasOwnProperty(key)) {
          if (!saveOld) {
            entry[key] = value;
          } else {
            if (entry[key].includes(value[0])) {
              entry[key] = entry[key].filter(item => item !== value[0]);
            } else {
              entry[key] = [...entry[key], ...value];
              entry[key] = Array.from(new Set(entry[key]));
            }
          }
          found = true;
        }
      });
      if (!found) {
        let entry = {};
        entry[key] = value;
        this.options.push(entry)
      }
      this.priceCalculate();
    },
    async initDefaultOptions() {
      if (this.product?.options === undefined) {
        return;
      }
      for (const option of this.product.options) {
        if (option.required === "1") {
          if (option.type === "select" && option?.sizes) {
           this.updateOption(option.product_option_id, option.sizes[0].product_option_value_id)
           return;
          }
        }
      }
    }
  },

}
</script>
